<div class="apple-card">
  <div class="apple-card-header">
    <div class="apple-card-icon coin-icon">
      <mat-icon>monetization_on</mat-icon>
    </div>
    <div class="apple-card-title-section">
      <h3>Coins verwenden</h3>
    </div>
  </div>
  <div class="apple-card-content">
    <div *ngIf="customer as customerData" class="balance-display">
      <div class="balance-icon-wrapper">
        <mat-icon>account_balance_wallet</mat-icon>
      </div>
      <div class="balance-info">
        <span class="balance-label">Verfügbare Coins</span>
        <span class="balance-amount">{{ $any(customerData)?.coinsCurrent }}</span>
      </div>
    </div>

    <div *ngIf="order?.status?.name === 'Ausstehend'" class="apple-warning-box">
      <mat-icon>error_outline</mat-icon>
      <div class="warning-text">
        <strong>Hinweis:</strong> Sie können Coins nicht verwenden, solange der Bestellstatus auf <strong>Ausstehend</strong> steht.
      </div>
    </div>

    <div *ngIf="order?.status?.name === 'Genehmigt'" class="apple-warning-box">
      <mat-icon>error_outline</mat-icon>
      <div class="warning-text">
        <strong>Hinweis:</strong> Coins wurden für diese Bestellung bereits verwendet.
      </div>
    </div>

    <div *ngIf="!canUseCoins() && order?.status?.name !== 'Ausstehend' && order?.status?.name !== 'Genehmigt' && order?.coinsUsed! <= 0" class="apple-error-box">
      <mat-icon>error</mat-icon>
      <div class="error-text">
        <strong>Fehler:</strong> Coins können nur bis zu 2 Werktage vor dem Dispo-Datum der Bestellung verwendet werden.
      </div>
    </div>

    <form class="coin-input-form">
      <mat-form-field appearance="outline" class="coin-input-field">
        <mat-label>Anzahl Coins</mat-label>
        <input
          matInput
          placeholder="0"
          name="coinsUsed"
          type="number"
          [disabled]="isCoinsDisabled()"
          [(ngModel)]="coinsUsed"
          (ngModelChange)="onCoinsUsedChange($event)"
        />
        <mat-icon matPrefix>savings</mat-icon>
      </mat-form-field>
    </form>
  </div>
  <div *ngIf="customer as customerData" class="apple-card-actions">
    <button
      type="submit"
      (click)="openConfirmDialog()"
      mat-flat-button
      class="apple-button apple-button-primary"
      [disabled]="
        !coinsUsed ||
        isCoinsDisabled() ||
        $any(customerData)?.coinsCurrent < coinsUsed
      "
    >
      <mat-icon>paid</mat-icon>
      <span>Coins verwenden</span>
    </button>
  </div>
</div>
